var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"}}),_c('path',{attrs:{"d":"M12.5 7H11v6l5.3 3.1.8-1.2-4.5-2.7-.1-5.2z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }